import { formatMoney } from "src/utils/formatter";
import { dt } from "src/utils/documentsI18n";
 
export const DetailGlosa = ({ value }) => {
  return (
    <div className="tw-pb-[12px] tw-overflow-x-hidden">
      <div className="tw-max-w-[400px] tw-pt-[12px]">
        <table className="tw-w-[680px] tw-border-collapse tw-border-[1px] tw-border-gray-200">
          <thead>
            <tr className="tw-bg-gray-50">
              <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px] tw-w-[180px]">NOMBRE</th>
              <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px] tw-w-[200px]">{dt('detail.matchesSection.descriptionColumn')}</th>
              {/* <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px]">UNIDAD</th> */}
              <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px] tw-w-[140px]">PRECIO UNITARIO</th>
              <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px] tw-w-[50px]">CANTIDAD</th>
              {/* <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px]">DESCUENTO</th> */}
              <th className="tw-text-[11px] tw-font-medium tw-text-gray-700 tw-px-[12px] tw-py-[9px] tw-w-[110px]">TOTAL NETO</th>
            </tr>
          </thead>
          <tbody>
            {value.description.map((detail, index) => (
              <tr
                key={index}
                className={`tw-border-b-[1px] tw-border-gray-200 ${
                  index % 2 === 0 ? "tw-bg-white" : "tw-bg-gray-50"
                }`}
              >
                <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  {`${detail.name || "s/i"}`}
                </td>
                <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  {detail.description || "s/i"}
                </td>
                {/* <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  {detail.unit || "s/i"}
                </td> */}
                <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  $ {formatMoney(detail.unit_price) || "s/i"}
                </td>
                <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[14px] tw-py-[9px]">
                  {detail.quantity || "s/i"}
                </td>
                {/* <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  {detail.discount || "s/i"}
                </td> */}
                <td className="tw-text-[10px] tw-font-normal tw-text-gray-700 tw-px-[12px] tw-py-[9px]">
                  $ {formatMoney(detail.total_price) || "s/i"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
